import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { FieldArray } from 'formik';
import SigniteToggle from '../../../../ui-elements/toggle-switch/signiteToggleSwitch';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { json } from 'react-router-dom';

export const FamilyDetailsForm = ({ handleChange, values }) => (
  <div className="signite-form">
    <Row className="mb-3">
      <BSForm.Group as={Col} controlId={`spouseOccupation`}>
        <BSForm.Label>Spouse's Current Occupation</BSForm.Label>
        <BSForm.Select name={'spouseOccupation'} onChange={handleChange} value={values.spouseOccupation}>
          <option value="NOT_APPLICABLE">--Select--</option>
          <option value="SERVICE">Service</option>
          <option value="SELF_EMPLOYED">Self Employed</option>
          <option value="RETIRED">Retired</option>
        </BSForm.Select>
      </BSForm.Group>
      <BSForm.Group as={Col}></BSForm.Group>
      <BSForm.Group as={Col}></BSForm.Group>
    </Row>

    <Row className="mb-3">
      <BSForm.Group as={Row} controlId={'haveChildren'}>
        <Col>
          <BSForm.Label>Do you have children?</BSForm.Label>
          <SigniteToggle
            id={'haveChildren'}
            dataYes={'Yes'}
            dataNo={'No'}
            fieldInput={{
              onChange: handleChange,
              value: values.haveChildren,
            }}
          />
        </Col>
      </BSForm.Group>
    </Row>
    {values.haveChildren === true && (
      <Row className="mb-3">
        <BSForm.Group as={Col} controlId="noOfChildren">
          <BSForm.Label>Number of Children</BSForm.Label>
          <BSForm.Control
            type="number"
            min={0}
            max={25}
            name={`noOfChildren`}
            onChange={handleChange}
            value={values.noOfChildren}
          />
        </BSForm.Group>
        <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
        <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
      </Row>
    )}
  </div>
);
